<template>
  <v-container fluid :pa-0="$vuetify.breakpoint.smAndDown">
    <v-layout
    >
      <v-flex>
        <v-card :elevation="$vuetify.breakpoint.smAndDown ? 0 : 2">
          <v-card-title>
            <documents-toolbar
              @refresh="loadData"
            />
          </v-card-title>
          <loading v-if="loading"/>
          <component
            v-else-if="content.length"
            :is="documentsDisplayComponent"
            @delete="openDeleteConfirmationModal"
            @openDocument="openDocument"
            :content="content"
            :currencies="currencies"
            :statuses="statuses"
            :allowEditList="allowEditList"
            :loading="loading"
          />
          <empty-table
            v-else
            :emptyText="'Нет документов'"
          />
          <documents-delete-confirmation-modal
            ref="deleteConfirmationModal"
            @ok="deleteDocument"
          />
          <v-snackbar
            color="success"
            :timeout="5000"
            :bottom="true"
            v-model="showMessage"
          >
            {{ message }}
            <v-btn flat icon @click.native="showMessage = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-snackbar>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DocumentsApi from '../api'
import DocumentsTable from './DocumentsTable'
import DocumentsList from './DocumentsList'
import DocumentsToolbar from './DocumentsToolbar'
import DocumentsDeleteConfirmationModal from './DocumentsDeleteConfirmationModal'
import emptyTable from '@/components/helpers/EmptyTable'
import Loading from '@/components/helpers/Loading'

export default {
  name: 'documents',
  components: {
    DocumentsTable,
    DocumentsList,
    DocumentsToolbar,
    DocumentsDeleteConfirmationModal,
    Loading,
    emptyTable
  },
  data () {
    return {
      loading: false,
      allowEditList: [
        'schet',
        'rezervirovanie'
      ],
      statuses: [],
      currencies: {},
      showMessage: false,
      message: '',
      documentForDelete: {
        docId: '',
        docName: ''
      },
      content: []
    }
  },
  computed: {
    documentsDisplayComponent () {
      return this.$vuetify.breakpoint.smAndDown ? 'documents-list' : 'documents-table'
    }
  },
  methods: {
    openCatalog (item) {
      this.$router.push({ name: 'catalog/document', params: { docId: item.doc_id, docName: item.name } })
    },
    openDocument (document) {
      this.$router.push({ name: `documents/${document.name}`, params: { docId: document.doc_id } })
    },
    openDeleteConfirmationModal (item) {
      this.$refs.deleteConfirmationModal.open(item)
    },
    async deleteDocument (item) {
      this.message = ''
      this.showMessage = false
      let response = await DocumentsApi.deleteDocument({ name: item.name, docId: item.doc_id })
      if (response.success) {
        const index = this.content.indexOf(item)
        this.content.splice(index, 1)
        this.message = 'Документ удален'
        this.showMessage = true
      } else {
        console.log(response.error)
      }
    },
    async loadData () {
      this.loading = true
      let response = await DocumentsApi.getList()
      if (response.success) {
        this.content = response.data
        this.statuses = response.statuses
        this.currencies = response.currencies
      } else {
        console.log(response.error)
      }
      this.loading = false
    }
  },
  async mounted () {
    await this.loadData()
  }
}
</script>

<style lang="stylus">
  .t-documents-list {
    .v-list__tile {
      padding-right: 0;
      overflow: hidden;
    }

    .v-list__tile__content {
      min-width: auto;
    }

    .v-list__tile__action {
      position: absolute;
      right: 0;
      padding: 0;
      margin: 0;
      flex-direction: row;
      min-width: 36px;

      .v-btn {
        box-shadow: none;
        height: 100%;
        border-radius: 0;
      }
    }
  }

  .rashodnayanakladnaya-status {
    margin: 4px 0 0 0;
  }

  .rashodnayanakladnaya-title {
    display: inline-block;
  }

  .currency {
    display: inline-block;
    width: 14px;
    text-align: left;
  }
</style>
